import Vue from 'vue/dist/vue.esm'

Vue.component(
  'card-tutorial-date-vue',
  () => import(/* webpackChunkName: "[request]" */ 'components/CardTutorialDate.vue')
)
